site.faq = {
	init : function() {
		$('.more a', '#faq').on('click', function(e) {
			e.preventDefault();
			var $this = $(this);
			var state = $this.data('state');
			if (state === 'less') {
				$this.closest('.category').find('section.noshow').slideDown();
				$this.data('state', 'more');
				$this.text($this.data('less'));
				site.accordion.setHeight();
			}
			else {
				$this.closest('.category').find('section.noshow').slideUp();
				$this.text($this.data('more'));
				$this.data('state', 'less');
			}
		});
	}
};

site.inits.push('site.faq.init();');